// extracted by mini-css-extract-plugin
export default {"root":"HomePage_root__2bR58","outlet":"HomePage_outlet__yyjxf"};